<ws-modal-wrapper headerLabel="Tasks"
                  [hideFooter]="true"
                  [excludeModalStyling]="true"
                  [backdropClick]="true"
                  [disableMove]="true"
                  [isEditing]="canDismiss"
                  (cancel)="closeModal()">
    @for (taskGroupCollection of taskGroupsBySequence; track taskGroupCollection.sequence; let i = $index) {
        <div>
            @if (taskGroupCollection.taskGroups[0].sequence > 1 && taskGroupCollection.taskGroups.length > 1) {
                <div>
                    <task-series-arrows [chevronWidth]="chevronWidth"
                                        [padding]="taskSeriesPadding"
                                        [manyLength]="taskGroupCollection.taskGroups.length">
                    </task-series-arrows>
                </div>
            }
            @for (taskGroup of taskGroupCollection.taskGroups; track taskGroup.id) {
                <div class="d-inline-block pe-3"
                     style="vertical-align: top;">
                    <task-series [taskGroup]="taskGroup"
                                 [chevronWidth]="chevronWidth"
                                 [padding]="chevronPadding"
                                 [popoverLeftOrRight]="getPlacement(i)"
                                 [waitingOnServer]="waitingOnServer"
                                 [allowAddYearPrompt]="!!params.onAddYearPrompt"
                                 (addYearPromptRequested)="addYearPromptRequested($event)"
                                 (taskOperationStarted)="taskOperationStarted($event)"
                                 (updateData)="updateData($event)"
                                 (entityTaskUpdated)="taskUpdated()">
                    </task-series>
                </div>
            }
            @if (taskGroupCollection.taskGroups[0].sequence > 1 && taskGroupCollection.taskGroups.length > 1 && taskGroupsBySequence[i + 1]) {
                <div>
                    <task-series-arrows [chevronWidth]="chevronWidth"
                                        [padding]="taskSeriesPadding"
                                        [manyLength]="taskGroupCollection.taskGroups.length"
                                        [manyToOne]="true">
                    </task-series-arrows>
                </div>
            }
        </div>
    }
</ws-modal-wrapper>
